import { Col, Container, Input, Row } from "reactstrap";
import DepartmentSapParameter from "../../../../../backoffice/dtos/groups/DepartmentSapParameter";
import { ChangeEvent, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Group } from "../../../../../backoffice/dtos/groups/group";
import SapParameterInputType from "./models/SapParameterValues";
import { sapParameterValueTypesOptions } from "./models/SapParameterValueTypeOption";

export default function DepartmentsSapParameterEdit(
    {
        isOpen,
        toggle,
        errors,
        group,
        sapParameters,
        setSapParameters
    }: {
        isOpen: boolean;
        toggle: () => void;
        errors: Map<string, string> | undefined;
        group: Group,
        sapParameters: DepartmentSapParameter[];
        setSapParameters: (sapParametersFunc: (sapParameters: DepartmentSapParameter[]) => DepartmentSapParameter[]) => void;
    }
) {
    const {t} = useTranslation(['department_info','common'])

    const onValueChange = useCallback((label: string, value: string) => {
        setSapParameters(ref => {
            let item = ref.find(m => m.fieldName === label);
            ref = ref.filter(m => m.fieldName !== label);

            if (!item) {
                return ref;
            }

            item.value = value;

            return [...ref, item]
        });
    }, [setSapParameters]);

    const onValueTypechange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const label = e.target.name;
        const value = e.target.value;

        setSapParameters(ref => {
            let item = ref.find(m => m.fieldName === label);
            ref = ref.filter(m => m.fieldName !== label);

            if (!item) {
                item = {
                    groupId: group.id,
                    fieldName: label,
                    valueType: value,
                    value: ""
                }
            }

            item.valueType = value;
            item.value = "";

            return [...ref, item]
        });
    }, [setSapParameters])

    return (
        <Container>
            {
                sapParameters.map(sp => {
                    return <>
                        <Row className="gy-1 mt-2" key={sp.fieldName}>
                            <Col lg={5} className="d-flex align-items-center justify-content-end">
                                {t(sp.fieldName)} *
                            </Col>
                            <Col>
                                <Input type="select" id={sp.fieldName} name={sp.fieldName} onChange={onValueTypechange} value={sp.valueType}>
                                    {
                                        sapParameterValueTypesOptions.map(m => (
                                            <option value={m.value}>{m.label}</option>
                                        ))
                                    }
                                </Input>
                            </Col>
                            <Col>
                                {
                                    <SapParameterInputType label={sp.fieldName} valueType={sp.valueType} value={sp.value} onValueChange={onValueChange} />
                                }
                            </Col>
                        </Row>
                        {
                            errors && errors.has(sp.fieldName) &&
                                <Row className="gy-1" key={`${sp.fieldName}_error`}>
                                    <Col lg={5}>
                                    </Col>
                                    <Col>
                                        <span className="text-danger">{errors.get(sp.fieldName)}</span>
                                    </Col>
                                </Row>
                        }
                    </>
                })
            }
        </Container>
    );
}